import React from "react";
import Slider from "react-slick";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};


    function SlickSlider(sliderData=[]){
    const sliderValue = sliderData.sliderData;
            return(
                <div className="slider-container">
                     <Slider className="arrows-slick accommodations-slick" {...settings}>
                     {sliderValue.map((data,index)=>{
                        //  console.log("Working"+index);
                         if(data.image != '') {
                            return (<div key={index}>
                                 <img alt={data.des} src={data.image} />
                                 <p>{data.des} </p>
                             </div>);
                            }
                        })
                     } 
                     </Slider>
                </div>
            );
    }
export default SlickSlider;